import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { PersonShowHistoriesState } from './types';
import { fetchPersonHistories } from '../../../services/personProfiles';
import { PersonShowModal } from '../personShowModal';

type Props = {
  isPc: boolean;
  personId: number;
  isShow: boolean;
  onHandleOpenModal: (target: string, title: string) => void;
};

export const Component: FunctionComponent<Props> = ({
    isPc,
    personId,
    isShow,
    onHandleOpenModal,
 }) => {
  const [state, setState] = useState<PersonShowHistoriesState>({
    favoritesCounts: 0,
    entriesCounts: 0,
    scoutsCounts: 0,
    favorites: [],
    entries: [],
    scouts: [],
    isModal: false,
    scoutId: null,
    scoutTitle: '',
    scoutCreatedAt: '',
    scoutMessage: '',
    modalTitle: '',
    target: '',
  });

  useEffect(() => {
    fetchHistories();
  }, []);

  const fetchHistories = async () => {
    try {
      const response = await fetchPersonHistories(personId);
      setState(prev => ({
        ...prev,
        favoritesCounts: response.favoritesCounts,
        entriesCounts: response.entriesCounts,
        scoutsCounts: response.scoutsCounts,
        favorites: response.favorites,
        entries: response.entries,
        scouts: response.scouts,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenModal = (
    scoutId: number,
    scoutTitle: string,
    scoutCreatedAt: string,
    scoutMessage: string
  ) => {
    const newModal = !state.isModal
    document.body.style.overflow = newModal ? 'hidden' : 'visible'
    setState(prev => ({
      ...prev,
      isModal: newModal,
      target: 'scout',
      modalTitle: 'スカウト履歴',
      scoutId: scoutId,
      scoutTitle: scoutTitle,
      scoutCreatedAt: scoutCreatedAt,
      scoutMessage: scoutMessage,
    }));
  };

  const handleCloseModal = (target: string, title: string) => {
    const newModal = !state.isModal
    document.body.style.overflow = newModal ? 'hidden' : 'visible'
    setState(prev => ({
      ...prev,
      isModal: newModal,
    }));
  };

  return (
    <>
      <Presentation
        favoritesCounts={state.favoritesCounts}
        entriesCounts={state.entriesCounts}
        scoutsCounts={state.scoutsCounts}
        favorites={state.favorites}
        entries={state.entries}
        scouts={state.scouts}
        handleOpenModal={handleOpenModal}
      />
      {!isShow && (
        <PersonShowModal
          isPc={false}
          handleOpenModal={handleCloseModal}
          title="スカウト履歴"
          target="scout"
          isModal={state.isModal}
          resumeLoading={false}
          personId={personId}
          scoutId={state.scoutId ?? undefined}
          scoutTitle={state.scoutTitle}
          scoutCreatedAt={state.scoutCreatedAt}
          scoutMessage={state.scoutMessage}
        />
      )}
    </>
  );
};
